/**
 * The stable code a chat door answers with when the conversation it names is
 * closed to the person asking — rendered as `error.code` in the canonical
 * envelope, `{ success: false, error: { code, message } }`, with status 403.
 *
 * A client switches on THIS value, never on the message text: the message is
 * prose for a human and may be reworded, the code is the contract. The embed
 * widget reads it to tell "this conversation is gone, start a fresh one" apart
 * from a network fault or an authentication failure, which call for opposite
 * responses — re-initialising on the first, retrying or re-authenticating on the
 * other two.
 *
 * Today it names ONE state: a chat whose `status` is `DELETED`. Retention's
 * DELETE level hides a conversation from its end user, and the refusal is
 * asymmetric by design — every write door refuses it, while a read refuses it
 * only for the end user (the embed widget) and serves it unchanged to an
 * authenticated member of the organization who already holds the id.
 * `ARCHIVED` is NOT this code: a closed conversation stays visible and writable
 * on these doors.
 *
 * DELETE is recoverable and SHRED is not. A DELETED conversation's rows all
 * survive in the database and the status can be flipped back; what changes is
 * who is served it. It is also hidden from the organization's own inbox — every
 * branch of the operator's status filter excludes DELETED — so an operator
 * cannot FIND it there, only read it by an id already in hand or ask the Public
 * API v1 conversations list for that status explicitly. SHRED is the level that
 * removes the rows and the stored objects, and nothing brings those back.
 */
export const CONVERSATION_CLOSED_CODE = "CONVERSATION_CLOSED" as const;

export type ConversationClosedCode = typeof CONVERSATION_CLOSED_CODE;
